var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgJira = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2898 7.55227L8.40493 0.667371L7.73756 0L2.55488 5.18268L0.185293 7.55227C0.0666438 7.67107 0 7.8321 0 8C0 8.1679 0.0666438 8.32893 0.185293 8.44773L4.92024 13.1827L7.73756 16L12.9202 10.8173L13.0005 10.7371L15.2898 8.44773C15.4085 8.32893 15.4751 8.1679 15.4751 8C15.4751 7.8321 15.4085 7.67107 15.2898 7.55227ZM7.73756 10.3654L5.3722 8L7.73756 5.63464L10.1029 8L7.73756 10.3654Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73755 5.63516C6.99361 4.89113 6.57428 3.88298 6.57111 2.83083C6.56795 1.77868 6.98121 0.768022 7.72066 0.0195312L2.54431 5.19377L5.36163 8.01108L7.73755 5.63516Z",
    fill: "url(#paint0_linear_2863_97872)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1092 7.99414L7.73755 10.3658C8.10767 10.7357 8.40127 11.1749 8.60159 11.6583C8.80191 12.1418 8.90501 12.6599 8.90501 13.1832C8.90501 13.7064 8.80191 14.2246 8.60159 14.708C8.40127 15.1914 8.10767 15.6306 7.73755 16.0005L12.9266 10.8115L10.1092 7.99414Z",
    fill: "url(#paint1_linear_2863_97872)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2863_97872",
    x1: 7.31517,
    y1: 3.24234,
    x2: 4.0121,
    y2: 6.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2863_97872",
    x1: 8.1895,
    y1: 12.7312,
    x2: 11.4862,
    y2: 9.43448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgJira);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Jira.217a01b37877dcd774acce53d984c696.svg";